import { Button } from '@sunwebgroup/uds-ui/button'
import { Sheet } from '@sunwebgroup/uds-ui/sheet'
import { Typography } from '@sunwebgroup/uds-ui/typography'
// TODO: migrate to @sunwebgroup/uds-ui when available
import { useBreakpoints } from '@sunwebgroup/ui-components/uds'
import { useState } from 'react'
import { useIntl } from '@/intl'
import styles from './MobileFilters.module.css'
import { PartyCompositionFilter } from './PartyCompositionFilter'

export function MobileFilters() {
  const { isDesktop } = useBreakpoints()
  const [showFilters, setShowFilters] = useState(false)
  const intl = useIntl()

  if (isDesktop) {
    return null
  }

  return (
    <div className={styles.wrapper}>
      <Sheet.Root open={showFilters} onOpenChange={setShowFilters}>
        <Sheet.Trigger>
          <Button size="S" variant="primary">
            {intl.formatMessage({ id: 'reviews_change_filters' })}
          </Button>
        </Sheet.Trigger>
        <Sheet.Body side="bottom">
          <Sheet.Header
            closeLabel={intl.formatMessage({ id: 'close' })}
            titleLabel={intl.formatMessage({ id: 'reviews_filters' })}
          />
          <Sheet.Content className={styles.sheetContent}>
            <div className={styles.partyCompositionFilterLabel}>
              <Typography variant="body-m-regular-tight">
                {intl.formatMessage({ id: 'reviews_party_composition_label' })}
              </Typography>
            </div>
            <PartyCompositionFilter />
          </Sheet.Content>
          <Sheet.Footer className={styles.sheetFooter}>
            <div className={styles.footerWrapper}>
              <Button variant="primary" fullWidth onClick={() => setShowFilters(false)}>
                {intl.formatMessage({ id: 'save_button_text' })}
              </Button>
            </div>
          </Sheet.Footer>
        </Sheet.Body>
      </Sheet.Root>
    </div>
  )
}
